import React from 'react';

interface AvatarFallbackProps {
    firstName?: string;
    lastName?: string;
    name?: string;
    email?: string;
    size?: number;
    className?: string;
    style?: React.CSSProperties;
}

const getInitials = (firstName?: string, lastName?: string, name?: string, email?: string) => {
    const first = (firstName || '').trim();
    const last = (lastName || '').trim();

    if (first || last) {
        const firstInitial = first ? first[0] : '';
        const lastInitial = last ? last[0] : '';
        return `${firstInitial}${lastInitial}`.toUpperCase() || '?';
    }

    const parsedName = (name || '').trim();
    if (parsedName) {
        const parts = parsedName.split(/\s+/);
        if (parts.length >= 2) {
            return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
        }
        return parts[0].slice(0, 2).toUpperCase();
    }

    const parsedEmail = (email || '').trim();
    if (parsedEmail) {
        return parsedEmail[0].toUpperCase();
    }

    return '?';
};

const AvatarFallback: React.FC<AvatarFallbackProps> = ({
    firstName,
    lastName,
    name,
    email,
    size = 42,
    className = '',
    style = {},
}) => {
    const initials = getInitials(firstName, lastName, name, email);

    return (
        <div
            className={`avatar-fallback ${className}`.trim()}
            style={{
                width: size,
                height: size,
                borderRadius: '50%',
                backgroundColor: '#f3f4f6',
                background: '#f3f4f6',
                color: '#111827',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: size * 0.4,
                overflow: 'hidden',
                textTransform: 'uppercase',
                ...style,
            }}
            aria-label="User initials"
        >
            {initials}
        </div>
    );
};

export default AvatarFallback;

